export default "__VITE_ASSET__BlEN5j0V__"